

















import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import { CompetencySetting } from '@/models/competency/competency-setting';
import { Competency } from '@/models/competency/competency';
import { studentFilterModule } from '@/store/modules/frames/student-filters.module';
import { masterModule } from '@/store/modules/entities/master.module';
import { groupModule } from '@/store/modules/entities/group.module';
import { CompetencyRankingSettingRequest } from '@/models/competency/competency-ranking-setting-request';
import { SchoolGroupSearch } from '@/models/school-group/school-group-search';

@Component({
  name: 'GClassManagementShowCompetencySetting',
  components: {},
})
export default class GClassManagementShowCompetencySetting extends mixins(GPageBase) {
  selectedCompetencies: any[] = [];

  mounted() {
    masterModule.fetchCompetency();
    this.setInitialCompetency();
  }

  setInitialCompetency(): void {
    if (this.schoolGroupCompetency) {
      this.selectedCompetencies = this.schoolGroupCompetency.map((d: CompetencySetting) => d.competencyID);
    }
  }

  get competencies(): Competency[] {
    return masterModule.competencies;
  }

  get schoolGroupCompetency(): CompetencySetting[] {
    return groupModule.competencySettings;
  }

  get targetType(): number {
    return studentFilterModule.targetType;
  }

  get targetID(): number {
    return studentFilterModule.targetID;
  }

  handleCompetencySubmit(): void {
    this.$emit('modalClose', false);
    const params: CompetencyRankingSettingRequest = {
      competencyIDs: this.selectedCompetencies,
      targetType: this.targetType,
      targetID: this.targetID,
    };
    groupModule.updateCompetencySetting(params).then((_d: any) => {
      groupModule.fetchCompetencySetting({
        targetType: this.targetType,
        targetID: this.targetID,
      } as SchoolGroupSearch);
    });
  }
}
